/******************* Monogram Popup JS *************************/
$(document).ready(function(){
$(document).on('click','.rd-mgl-heading',function(){
    $('.rd-mgl-heading').removeClass('is-active');
    $(this).addClass('is-active');
    var active_tab = $(this).attr('data-type');
    $(this).parents('.monogram-section-popup').find('.rd-mgl-tab-contents .rd-mgl-tab-content').removeClass('is-active');
    $(this).parents('.monogram-section-popup').find('.rd-mgl-tab-contents .rd-mgl-tab-content[data-tab-active="'+active_tab+'"]').addClass('is-active');

});

function  logo_remove_cls() {
    $('.rd-mgl-field-logo .rd-mgl-logo-upload-box').find('.rd-mgl-logo-txt').removeClass('is-active');
     $('.rd-mgl-field-logo .rd-mgl-logo-upload-box').find('.rd-mgl-logo-txt.type-default').addClass('is-active'); 
}

$(document).on('change',"#monogram-logo",function(){
var input_file = $('#monogram-logo').val(); 
if(input_file.length >0){
$('.rd-mgl-field-logo .rd-mgl-logo-upload-box').find('.rd-mgl-logo-txt').removeClass('is-active');
$('.rd-mgl-field-logo .rd-mgl-logo-upload-box').find('.rd-mgl-logo-txt.rd-mgl-logo-remove').addClass('is-active');
$('.rd-mgl-field-logo .rd-mgl-logo-upload-box').find('.rd-mgl-logo-txt.type-success').addClass('is-active');
}else{
 logo_remove_cls()
}

if($('.rd-mgl-content-inner .rd-mgl-field #rd-mgl-input').val().length > 0 ){
$('.rd-mgl-content-inner .rd-mgl-field #rd-mgl-input').val('');
$('.rd-mgl-preview-overlay p').html('ABC');

}
});

$('.rd-mgl-logo-txt.rd-mgl-logo-remove').click(function(e){
    e.preventDefault();
    $('#monogram-logo').val('');
     logo_remove_cls()
});

$(document).on('keyup','.rd-mgl-content-inner .rd-mgl-field #rd-mgl-input',function(){
    var input_text = $(this).val();
  if($('.rd-mgl-tab-content-text .horizontal-selector.layout-changer').hasClass('selected')){
    $('#horizontal_text').val('horizontal');
    $('#horizontal_text').attr('name','properties[_Monogramming-Layout]');
    $('#veritical_text').val('');
     $('#veritical_text').attr('name','');
  }else if($('.rd-mgl-tab-content-text .vertical-selector.layout-changer').hasClass('selected')){
     $('#veritical_text').val('veritical');
     $('#veritical_text').attr('name','properties[_Monogramming-Layout]');
     $('#horizontal_text').val('');
    $('#horizontal_text').attr('name','');
     }
    $('.rd-mgl-preview-overlay p').html(input_text);
    if($('.rd-mgl-preview-overlay p').html() == ''){
    $('.rd-mgl-preview-overlay p').html('ABC');
     $('#horizontal_text').val('');
     $('#horizontal_text').attr('name','');
}
if ($('#monogram-logo').val().length > 0){
$('#monogram-logo').val('');
logo_remove_cls()
}
});

$(document).on('click','.rd-monogram-save',function(){
$('.monogram-section-popup').removeClass('active');
$("body").removeClass('pop-open');
});
$(document).on('click','.rd-mgl-tab-content-text .layout-changer svg.monogram-layout-selector',function(){

    $(this).parent('.rd-mgl-tab-content-text .layout-changer').addClass('selected');
    $('.rd-mgl-tab-content-text .layout-changer').not($(this).parent('.rd-mgl-tab-content-text .layout-changer')).removeClass('selected');
   var vertical_icon =  $(this).parent('.layout-changer').hasClass('vertical-selector');
    if(vertical_icon){
    $('#veritical_text').attr('name','properties[_Monogramming-Layout]');
    $('#horizontal_text').attr('name','');
    $('#horizontal_text').val('');
    $('#veritical_text').val('veritical');

 $('.rd-mgl-preview-overlay p').css('transform', 'rotate(-90deg)');
    }else{
   $('#horizontal_text').attr('name','properties[_Monogramming-Layout]');
  $('#horizontal_text').val('horizontal');
    $('#veritical_text').attr('name','');
     $('#veritical_text').val('');
    $('.rd-mgl-preview-overlay p').css('transform', 'rotate(0deg)');
    }

});
$(document).on('click','.rd-mgl-tab-content-logo .layout-changer svg.monogram-layout-selector',function(){
$(this).parent('.rd-mgl-tab-content-logo .layout-changer').addClass('selected');
$('.rd-mgl-tab-content-logo .layout-changer').not($(this).parent('.rd-mgl-tab-content-logo .layout-changer')).removeClass('selected');
});
});

/******************* Monogram Popup JS End*************************/